
export const getPublicQuizzes = async (axiosInstance) => {
  const response = await axiosInstance.get(`public/quizzes`);
  return response.data;
}
